import { render } from "./ClientsDetail.vue?vue&type=template&id=138f0505"
import script from "./ClientsDetail.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ClientsDetail.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script